import * as React from 'react';
import { useIntl } from 'react-intl';

import { IconSolidLimitMargin } from '@notino/react-styleguide';
import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { resolveVoucherDiscount } from '../ProductBaseInfo/VoucherDiscount/useResolvedVoucherDiscount';
import { messages } from '../ProductBaseInfo/VoucherDiscount/VoucherDiscountInfo/messages';
import { pictogramMoreInfoPathname } from '../ProductTabContent/Pictograms/messages';

import {
  DermoLink,
  RecomendedByDermatologistsIcon,
  StyledBlackFridayIcon,
  StyledSummerBlackFridayIcon,
} from './styled';

interface IProductPictogramProps {
  attributes: NonNullable<
    GetCatalogProductViewQuery['productDetailByCatalogMasterId']
  >['variants'][number]['attributes'];
}

export const ProductPictogram: React.FC<IProductPictogramProps> = ({
  attributes,
}) => {
  const { formatMessage } = useIntl();
  const dermoMoreInfoPathname = formatMessage(pictogramMoreInfoPathname);
  const isFranceShop = useApolloClientHeaders()?.shopId === 'notino.fr';

  const voucherDiscount = resolveVoucherDiscount({ attributes });

  const shouldShowSummerBlackFriday =
    voucherDiscount?.tags?.includes('summerblackfriday');

  const shouldShowBlackFriday = voucherDiscount?.tags?.includes('blackfriday');

  const shouldShowMarginLimit = attributes.MarginUnderLimit;

  return (
    <>
      {shouldShowMarginLimit && (
        <IconSolidLimitMargin width="4rem" height="4rem" />
      )}

      {shouldShowSummerBlackFriday && (
        <StyledSummerBlackFridayIcon
          highlightedWordIndex={isFranceShop ? 2 : 0}
          text={formatMessage(messages.sbfLabel)}
          data-testid="summerBlackFridayIcon-pictogram"
        />
      )}

      {shouldShowBlackFriday && (
        <StyledBlackFridayIcon
          text={formatMessage(messages.blackFridayLabel)}
          data-testid="blackFridayIcon-pictogram"
        />
      )}

      {attributes?.Dermo && (
        <DermoLink target="_blank" href={dermoMoreInfoPathname}>
          <RecomendedByDermatologistsIcon data-testid="dermo-pictogram" />
        </DermoLink>
      )}
    </>
  );
};
